function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30 10.8l5.58 4.68v19.33H1V15.48l5.46-4.57M12.63 5.74L18.29 1l5.9 4.94",
  stroke: "#7F63FF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 34.81l17.29-14.48 17.29 14.48M35.58 15.48L24.67 25.2M1 15.48l10.91 9.72M22.95 11.22l-5.12 5.12-3.42-3.48",
  stroke: "#7F63FF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.74 20.59V5.94H30v14.51",
  stroke: "#7F63FF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEmailChecking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "31a3e8ae09583fafff7a9ecfe954b14c.svg";
export { SvgEmailChecking as ReactComponent };